import React from 'react';
import { HelpContent } from '@kineticdata/ui';

export const SpaceHelp = () => (
  <HelpContent>
    <h6>General</h6>
    <p>Name, slug, and bundle base directory.</p>

    <h6>Users</h6>
    <p>Manage users for a Space.</p>

    <h6>Integrator</h6>
    <p>
      Manage the Integrator infrastructure, such as the Integrator image or
      database.
    </p>

    <h6>Security</h6>
    <p>Rotate keys and manage background tasks.</p>

    <h6>Task</h6>
    <p>
      Manage the Task infrastructure, such as the Task image, database, and
      authentication secret. View the status of the Task engine and start or
      stop it if necessary.
    </p>
  </HelpContent>
);
